import React, { useState } from 'react';
import { Box, Button, Checkbox, FormControlLabel, Menu, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LinkIcon from '@mui/icons-material/Link';

const CheckboxDropdown = ({ options, disabled }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToggle = (value) => {
    setSelectedOptions((prev) =>
      prev.includes(value) ? prev.filter((option) => option !== value) : [...prev, value]
    );
  };

  return (
    <Box>
      <Button
        variant="outlined"
        color='action'
        onClick={handleClick}
        size='large'
        disabled={disabled}
      >
        <LinkIcon sx={{marginRight: 1}} />
        Quick Prompts
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {options.map((option) => (
          <MenuItem key={option.value}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedOptions.includes(option.value)}
                  onChange={() => handleToggle(option.value)}
                />
              }
              label={option.label}
            />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default CheckboxDropdown;